import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/site';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 border-t border-accent-200 bg-accent-100">
      <div className="mx-auto max-w-shell px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-line text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">{siteInfo.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              {siteInfo.slogan}。以「话题观察」的方式整理娱乐热点与网络讨论，记录事件的来龙去脉，而不是替你下结论。
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-mail-line" aria-hidden="true" />
              <a href={`mailto:${siteInfo.email}`} className="hover:text-primary-700">
                {siteInfo.email}
              </a>
            </p>
          </div>

          <nav aria-label="栏目导航">
            <h2 className="font-heading text-sm font-bold text-foreground-950">栏目</h2>
            <ul className="mt-4 flex flex-col gap-2.5">
              {categories.map((item) => (
                <li key={item.slug}>
                  <Link
                    to={`/topics?category=${item.slug}`}
                    className="text-sm text-foreground-700 transition-colors hover:text-primary-700"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="快捷导航">
            <h2 className="font-heading text-sm font-bold text-foreground-950">快捷导航</h2>
            <ul className="mt-4 flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-700 hover:text-primary-700">
                  首页实时上新
                </Link>
              </li>
              <li>
                <Link to="/topics" className="text-sm text-foreground-700 hover:text-primary-700">
                  话题库
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-700 hover:text-primary-700">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-foreground-700 hover:text-primary-700">
                  常见问题
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-foreground-700 hover:text-primary-700">
                  联系我们
                </Link>
              </li>
            </ul>
          </nav>

          <div>
            <h2 className="font-heading text-sm font-bold text-foreground-950">提供线索</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              如果你掌握可核实的公开信息，欢迎通过邮件或联系表单提供线索，我们会先判断真实性，再决定是否整理成话题。
            </p>
            <p className="mt-3 flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-shield-star-line" aria-hidden="true" />
              {siteInfo.tipEmail}
            </p>
            <Link
              to="/contact"
              className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              前往联系页
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>
        </div>

        <div className="mt-12 rounded-lg border border-accent-200 bg-background-50/70 p-4 text-xs leading-relaxed text-foreground-600">
          内容说明：站内所有话题均依据公开信息与网友讨论整理，以观察和讨论为目的，不构成对任何个人或机构的事实认定。如你认为相关内容存在失实，请通过联系页面提交说明，我们将及时核实与更正。
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-3 border-t border-accent-200 pt-6 text-xs text-foreground-600 sm:flex-row sm:items-center">
          <p>
            © {year} {siteInfo.name} · 内容整理于 {siteInfo.since} 年起
          </p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>本站为非商业信息整理站点</span>
            <span className="hidden sm:inline">·</span>
            <span>所有时间均为北京时间</span>
          </p>
        </div>
      </div>
    </footer>
  );
}